export const worksNames = {
  state: {
    works: 'works'
  },
  mutations: {
    LOAD_WORK: 'LOAD_WORK'
  },
  actions: {
    loadWorks: 'loadWorks'
  },
  getters: {
    works: 'works',
    getWork: 'getWork'
  }
}

export default worksNames
